// eslint-disable-next-line max-classes-per-file
export class MollieTerminal {
	ID:string = "";
	ProfileID:string = "";
	Status:string = "";
	Brand:string = "";
	Model:string = "";
	SerialNumber:string = "";
	Description:string = "";

	public constructor(data?:any){
		if (!data) return;
		this.ID = data.id || "";
		this.ProfileID = data.profileId || "";
		this.Status = data.status || "";
		this.Brand = data.brand || "";
		this.Model = data.model || "";
		this.SerialNumber = data.serialNumber || "";
		this.Description = data.description || "";
	}

	public toString():string {
		let name = this.Description || `${this.Brand} ${this.Model}`.trim() || this.ID;
		if (this.SerialNumber) {
			return `${name} (${this.SerialNumber})`;
		}
		return name;
	}
}

export class MollieTerminalPayment {
	ID:string = "";
	Status:string = "";
	Amount:number = 0;
	IsCancelable:boolean = false;
	StatusReasonCode:string = "";
	StatusReasonMessage:string = "";
	ChangePaymentStateURL:string = "";

	public constructor(data?:any){
		if (!data) return;
		this.ID = data.ID || "";
		this.Status = data.Status || "";
		this.Amount = data.Amount || 0;
		this.IsCancelable = data.IsCancelable || false;
		this.StatusReasonCode = data.StatusReasonCode || "";
		this.StatusReasonMessage = data.StatusReasonMessage || "";
		this.ChangePaymentStateURL = data.ChangePaymentStateURL || "";
	}

	public get isFinal():boolean {
		return this.Status != "open" && this.Status != "pending";
	}
}
